import PieChart from "components/charts/PieChart";
import { pieChartData, pieChartOptions } from "variables/charts";
import Card from "components/card";

const PieChartCard = ({ data }) => {
  function calculate_percentage(a, b) {
    let total = a + b;
    let per = (b * 100) / total;
    return { pending: per, current: (per - 100) * -1 };
  }

  const percentages = calculate_percentage(
    data.pieChartData[0],
    data.pieChartData[1]
  );
  return (
    <Card extra="rounded-[20px] p-3">
      <div className="flex flex-row justify-between px-3 pt-2">
        <div>
          <h4 className="text-lg font-bold text-navy-700 dark:text-white">
            Progreso global del mes
          </h4>
        </div>
      </div>

      {/* === Pie Chart === */}
      <div className="mb-auto flex h-[320px] w-full items-center justify-center">
        <PieChart options={data.pieChartOptions} series={data.pieChartData} />
      </div>

      {/* === NUEVO TEXTO DEBAJO DEL GRÁFICO === */}
      <div className="text-center mt-2 mb-4">
        <h4 className="text-md font-semibold text-navy-700 dark:text-white">
          Total de prendas:{" "}
          <span className="text-brand-500 font-bold">
            {Number(data.pieChartData[0]) + Number(data.pieChartData[1])}
          </span>
        </h4>
      </div>

      {/* === Porcentajes === */}
      <div className="flex flex-row !justify-between rounded-2xl px-6 py-3 shadow-2xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-brand-500" />
            <p className="ml-1 text-sm font-normal text-gray-600">Completado</p>
          </div>
          <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
            {Math.ceil(percentages.pending)}%
          </p>
        </div>

        <div className="h-11 w-px bg-gray-300 dark:bg-white/10" />

        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-[#6AD2FF]" />
            <p className="ml-1 text-sm font-normal text-gray-600">Pendiente</p>
          </div>
          <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
            {Math.floor(percentages.current)}%
          </p>
        </div>
      </div>
    </Card>
  );
};

export default PieChartCard;
